// eslint-disable
// this file created automatically, doesn't update it
// use yarn build:icons

import React from 'react';
import { IconType } from './IconType.auto-created';
import Icon from '@ant-design/icons';
import { ReactComponent as Account } from '@/assets/images/icons/account.svg';
import { ReactComponent as Arrowdown } from '@/assets/images/icons/arrow-down.svg';
import { ReactComponent as Arrowup } from '@/assets/images/icons/arrow-up.svg';
import { ReactComponent as Bell } from '@/assets/images/icons/bell.svg';
import { ReactComponent as Clipboard } from '@/assets/images/icons/clipboard.svg';
import { ReactComponent as Dollar } from '@/assets/images/icons/dollar.svg';
import { ReactComponent as Edit } from '@/assets/images/icons/edit.svg';
import { ReactComponent as Home } from '@/assets/images/icons/home.svg';
import { ReactComponent as Inbox } from '@/assets/images/icons/inbox.svg';
import { ReactComponent as Justify } from '@/assets/images/icons/justify.svg';
import { ReactComponent as Layout } from '@/assets/images/icons/layout.svg';
import { ReactComponent as Mappin } from '@/assets/images/icons/map-pin.svg';
import { ReactComponent as Maximize } from '@/assets/images/icons/maximize.svg';
import { ReactComponent as Paperclip } from '@/assets/images/icons/paperclip.svg';
import { ReactComponent as Piechart } from '@/assets/images/icons/pie-chart.svg';
import { ReactComponent as Rectangle } from '@/assets/images/icons/rectangle.svg';
import { ReactComponent as Scissors } from '@/assets/images/icons/scissors.svg';
import { ReactComponent as Settings } from '@/assets/images/icons/settings.svg';
import { ReactComponent as Sidenavcollapse } from '@/assets/images/icons/side-nav-collapse.svg';
import { ReactComponent as Sidenavexpand } from '@/assets/images/icons/side-nav-expand.svg';
import { ReactComponent as Subscript } from '@/assets/images/icons/subscript.svg';
import { ReactComponent as Superscript } from '@/assets/images/icons/superscript.svg';
import { ReactComponent as Template } from '@/assets/images/icons/template.svg';
import { ReactComponent as User } from '@/assets/images/icons/user.svg';
import { ReactComponent as Users } from '@/assets/images/icons/users.svg';

export const IconMap: Record<IconType, React.ComponentType<{ fill?: string }>> = {
  'account': ({ fill }) => <Icon component={() => <Account fill={fill}/>} />,
  'arrow-down': ({ fill }) => <Icon component={() => <Arrowdown fill={fill}/>} />,
  'arrow-up': ({ fill }) => <Icon component={() => <Arrowup fill={fill}/>} />,
  'bell': ({ fill }) => <Icon component={() => <Bell fill={fill}/>} />,
  'clipboard': ({ fill }) => <Icon component={() => <Clipboard fill={fill}/>} />,
  'dollar': ({ fill }) => <Icon component={() => <Dollar fill={fill}/>} />,
  'edit': ({ fill }) => <Icon component={() => <Edit fill={fill}/>} />,
  'home': ({ fill }) => <Icon component={() => <Home fill={fill}/>} />,
  'inbox': ({ fill }) => <Icon component={() => <Inbox fill={fill}/>} />,
  'justify': ({ fill }) => <Icon component={() => <Justify fill={fill}/>} />,
  'layout': ({ fill }) => <Icon component={() => <Layout fill={fill}/>} />,
  'map-pin': ({ fill }) => <Icon component={() => <Mappin fill={fill}/>} />,
  'maximize': ({ fill }) => <Icon component={() => <Maximize fill={fill}/>} />,
  'paperclip': ({ fill }) => <Icon component={() => <Paperclip fill={fill}/>} />,
  'pie-chart': ({ fill }) => <Icon component={() => <Piechart fill={fill}/>} />,
  'rectangle': ({ fill }) => <Icon component={() => <Rectangle fill={fill}/>} />,
  'scissors': ({ fill }) => <Icon component={() => <Scissors fill={fill}/>} />,
  'settings': ({ fill }) => <Icon component={() => <Settings fill={fill}/>} />,
  'side-nav-collapse': ({ fill }) => <Icon component={() => <Sidenavcollapse fill={fill}/>} />,
  'side-nav-expand': ({ fill }) => <Icon component={() => <Sidenavexpand fill={fill}/>} />,
  'subscript': ({ fill }) => <Icon component={() => <Subscript fill={fill}/>} />,
  'superscript': ({ fill }) => <Icon component={() => <Superscript fill={fill}/>} />,
  'template': ({ fill }) => <Icon component={() => <Template fill={fill}/>} />,
  'user': ({ fill }) => <Icon component={() => <User fill={fill}/>} />,
  'users': ({ fill }) => <Icon component={() => <Users fill={fill}/>} />,
}
